import React from 'react';

import {PortIncidents, useLastPortIncidents} from 'features/port';
import LoaderCentered from 'shared/ui/LoaderCentered/LoaderCentered';
import PlugNoIncidents from 'shared/ui/Plugs/PlugNoIncidents/PlugNoIncidents';

import {LAST_INCIDENTS_LIMIT} from '../../../lib/incidentTabs';

const PortIncidentsTab: React.FC = () => {
    const {pagination, isLoading, isFetching, tzString} = useLastPortIncidents(LAST_INCIDENTS_LIMIT);

    return (
        <>
            <LoaderCentered active={isFetching}/>
            <PortIncidents
                pagination={pagination}
                isLoading={isLoading}
                tzString={tzString}
                hidePagination
            />
            {!isLoading && pagination?.items.length === 0 && <PlugNoIncidents size="sm"/>}
        </>
    );
};

export default PortIncidentsTab;
